import { render, staticRenderFns } from "./EmailCreateContainer.vue?vue&type=template&id=4086fc02&scoped=true"
import script from "./EmailCreateContainer.vue?vue&type=script&lang=js"
export * from "./EmailCreateContainer.vue?vue&type=script&lang=js"
import style0 from "./EmailCreateContainer.vue?vue&type=style&index=0&id=4086fc02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4086fc02",
  null
  
)

export default component.exports